import { SET_FILTER_PRICES_ARRAY, SET_SORT_FILTER } from "../reducers/productFilterReducer/types";

export const handleSortInputChange = (e, dispatch) => {
    dispatch({ type: SET_SORT_FILTER, payload: e.target.value });
};


export const handlePriceChange = (value, dispatch) => {
    dispatch({ type: SET_FILTER_PRICES_ARRAY, payload: value });
};